const skipReadSpeakerClass = 'rs_skip_always';

export default skipReadSpeakerClass;
